import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import DataState from 'app/src/components/DataState';
import { currency } from 'app/src/utils/stringHelpers';

import { ASSET_FEES } from './queries';
import FeeEstimates from './FeeEstimates';
import { ContentContainer, TableContainer, PageTitle } from '../../elements';

const columns = [
  {
    key: 'type',
    label: 'Type',
  },
  {
    key: 'amount',
    label: 'Amount',
    content: ({ value }) => <Text>{currency(value)}</Text>,
  },
  {
    key: 'description',
    label: 'Description',
  },
  {
    key: 'feeEstimate',
    label: 'From Estimate?',
    content: (entry) => {
      if(entry.entry.feeEstimate) {
        return (
          <View>
            <Text>
              {`Accepted by ${entry.value.acceptedByString} through ${entry.value.acceptMethod}`}
            </Text>
          </View>
        )
      }
    }
  },
  {
    key: 'feeFiles',
    label: 'Files',
    content: (entry) => {
      return entry.entry.feeFiles.map(file => {
        return (
          <View>
            <Pressable
              onPress={() => window.open(file.url, '_blank')}
            >
              <Text>
                {file.filename}
              </Text>
            </Pressable>
          </View>
        )
      })
    }
  }
];

const Fees = ({ asset }) => {
  const { data, refetch } = useQuery(ASSET_FEES, { variables: { id: asset?.id } });

  return (
    <View>
      <ContentContainer>
        <PageTitle>Fees</PageTitle>
        <br /><br />
        <TableContainer>
          <DataTable.Simple
            data={data?.asset?.fees}
            columns={columns}
            pageLength="All"
            lengthMenu={false}
            htmlTable
          />
        </TableContainer>
      </ContentContainer>
      <FeeEstimates asset={asset} feeRefetch={refetch} />
    </View>
  );
};

export default Fees;
